import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IWall from 'components/interfaces/IWall';
import verticalProfileOffsets from 'services/configurator/verticalProfileOffsets';
import {
  SE0010,
  SE0020,
  SE0180,
  SEXXXX20,
} from 'components/configurator/types/verticalProfileTypes';

const getVerticalProfileOffset = (verticalProfile: string) => {
  if (verticalProfile === SE0010) {
    return verticalProfileOffsets.SE0010;
  }

  if (verticalProfile === SE0020) {
    return verticalProfileOffsets.SE0020;
  }

  if (verticalProfile === SE0180) {
    return verticalProfileOffsets.SE0180;
  }

  if (verticalProfile === SEXXXX20) {
    return verticalProfileOffsets.SEXXXX20;
  }

  return 0;
};

const getDoorStartAndDoorEnd = (door: IGlassWallDoor, glassWall: IWall) =>
  window.GetDoorStartAndDoorEnd(door, false, glassWall);

const getDoorPosition = (
  door: IGlassWallDoor,
  wall: IWall
): {
  glass: {
    left: number;
    right: number;
  };
  profile: {
    left: number;
    right: number;
  };
  totalAreaLength: number;
  verticalProfileOffsets: {
    left: number;
    right: number;
  };
} => {
  const startAndEnd = getDoorStartAndDoorEnd(door, wall);

  return {
    glass: {
      left: startAndEnd.leftPosGlass,
      right: startAndEnd.rightPosGlass,
    },
    profile: {
      left: startAndEnd.leftPosProfile,
      right: startAndEnd.rightPosProfile,
    },
    totalAreaLength: startAndEnd.rightPosProfile - startAndEnd.leftPosProfile,
    verticalProfileOffsets: {
      left: getVerticalProfileOffset(wall.leftVerticalProfileType),
      right: getVerticalProfileOffset(wall.rightVerticalProfileType),
    },
  };
};

export default getDoorPosition;
